import React from "react";
import { Popover } from "antd";
import { SketchPicker } from "react-color";

const AppColorPicker = ({
  value = "#131A22",
  pkey = "color",
  label,
  onChange,
}) => {
  return (
    <div className={"w-full"}>
      {label && (
        <label className="block text-sm font-semibold text-gray-900 mb-2">
          {label}
        </label>
      )}

      <div className="flex items-center justify-between w-full h-14 gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-2 hover:border-gray-300 transition">
        <div className="text-gray-400 text-3xl font-medium tracking-wide">
          {value}
        </div>
        <Popover
          trigger="click"
          placement="bottomRight"
          content={
            <SketchPicker
              color={value}
              onChange={(color) => onChange(pkey, color.hex)}
            />
          }
        >
          <div
            className="w-10 h-10 rounded-xl cursor-pointer border border-gray-200"
            style={{ backgroundColor: value }}
          />
        </Popover>
      </div>
    </div>
  );
};

export default AppColorPicker;
